import React from "react";
import {
  CONSTANTS,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
import { socialCityMaster } from "../../../constants/master-lists";
import { Table } from "react-bootstrap";
import NoDataMessage from "../../Shared/NoDataMessage";

const { DATA_NOT_FOUND } = CONSTANTS;

const {
  JournalistNOARanking,
  JournalistNOATrend,
  JournalistAnalysisPrint,
  SOV_NOA_TREND,
  SOVCCMTrend,
  SOVMAVTrend,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  CityWiseNOARanking,
  SOVNOARanking,
  SOVCCMRanking,
  SOVMAVRanking,
  CityWiseNOATrend,
  PublicationTonalityNOARanking,
  CityWiseMAVTonality,
  CityWiseCCMTonality,
  CityWiseCCMRanking,
  MediaExposureReport,
  TopLanguages,
  KeywordCloudNOA,
  WorldMap,
  CitySpecificReport,
  PLATFORM_RANK,
  PLATFORM_TREND,
  PLATFORM_TONALITY,
  StateWiseTrend,
  TonalityNAOTrend,
  CityWiseTonality,
  StateWiseTonality,
  TonalityWordCount,
  TonalityWCTrend,
  TagBasedTagAnalysis,
  EntityBasedTagAnalysis,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
  ThematicReportThemeWiseSpreadRanking,
  ThematicReportWithTopicArticle,
  ThematicReportWithTopicIndex,
  GeolocationZoneWiseTopPublication,
  GeolocationMarketSpread,
  SENTIMENTTABLEINDEX,
  SENTIMENTTABLEARTICLE,
} = REPORT_TYPES;

export const TableChart = ({
  graphApiResponse,
  chartTitle,
  identifier,
  onEntityClick,
  entityList,
  reportType,
  dataByReportType,
  editionList,
  countryWiseFeeds,
  type,
}) => {
  if (graphApiResponse) {
    if (reportType == MediaExposureReport || reportType == KeywordCloudNOA) {
      if (!Array.isArray(graphApiResponse) || !graphApiResponse.length) {
        return <NoDataMessage text="No Data found" />;
      }
    }
    if (!(reportType == MediaExposureReport || reportType == KeywordCloudNOA)) {
      if (!graphApiResponse.labels || !graphApiResponse.datasets) {
        return <NoDataMessage text="Graph type not supported." />;
      }
    }
  } else {
    if (reportType == WorldMap) {
      if (!countryWiseFeeds) {
        return <NoDataMessage text="Something went wrong !" />;
      }
    } else {
      return <NoDataMessage text="Something went wrong !" />;
    }
  }

  const handleCountClick = (e, { legend, label }) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;

      switch (reportType) {
        case EntityBasedTagAnalysis:
          routeParams.tagFilterName = legend;
          break;

        case TagBasedTagAnalysis:
          routeParams.tagFilterName = label;
          break;
      }

      if (reportType === KeywordCloudNOA || reportType == CitySpecificReport) {
        routeParams.keyword = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === SOVNOARanking ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTrend ||
        reportType === TonalityWCTrend ||
        reportType === MediaWiseNOARanking ||
        reportType === ThematicAnalysisTag ||
        reportType === TagBasedTagAnalysis
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_TREND ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTrend ||
        reportType === EditionWiseNOATrend ||
        reportType === TonalityWCTrend
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
      }
      if (reportType === JournalistAnalysisPrint) {
        routeParams.sourceName = clickedEntity;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType === ThematicAnalysisTag) {
        const clickedCategory = dataByReportType.filter(
          (elm) => elm.category_name == label
        )[0];
        routeParams.categoryId = clickedCategory.category_id;
      }
      if (reportType === ThematicAnalysisEntity) {
        const entityClicked = dataByReportType.filter(
          (elm) => elm.entity_name == label
        )[0];

        if (entityClicked && entityClicked.data && entityClicked.data.length) {
          const clickedCategory = entityClicked.data.filter(
            (elm) => elm.category_name == legend
          )[0];
          routeParams.categoryId = clickedCategory.category_id;
        }
      }
      if (reportType == REPORT_TYPES.SOV) {
        routeParams.date = label;
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === EditionWiseNOATrend ||
        reportType === CityWiseCCMRanking
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (reportType === MediaWiseNOARanking) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == label
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PublicationTonalityNOARanking ||
        reportType === CityWiseCCMTonality ||
        reportType === CityWiseMAVTonality ||
        reportType === CityWiseTonality ||
        reportType === StateWiseTonality ||
        reportType === TonalityWordCount ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == TopLanguages) {
        if (
          type == VERTICALS.V_SOCIAL ||
          type == VERTICALS.V_FORUM ||
          type == VERTICALS.V_BLOG
        ) {
          routeParams.language = legend;
        } else {
          const clickedLanguage = dataByReportType.filter((e) => {
            return e.language_name == legend;
          });
          if (clickedLanguage && clickedLanguage[0]) {
            routeParams.language = clickedLanguage[0].laguage_id;
          }
        }
      }
      if (reportType == WorldMap) {
        routeParams.country = legend;
        routeParams.countryFeeds = countryWiseFeeds;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channelType = label;
      }
      if (reportType != TopLanguages) {
        let entity =
          entityList &&
          entityList.filter(
            (elm) =>
              clickedEntity == elm.entity_display_name?.trim() ||
              clickedEntity == elm.name
          )[0];
        routeParams.entityId = entity && entity.id.toString();
      }
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  if (reportType == REPORT_TYPES.CitySpecificReport) {
    try {
      // Sorting data city wise
      let sumArray = [];
      for (const value of graphApiResponse.datasets) {
        let index = 0;
        for (const obj of value.data) {
          if (sumArray[index]) {
            sumArray[index].totalCount = sumArray[index].totalCount + obj.count;
          } else {
            sumArray[index] = {
              index: index,
              city: obj.city,
              totalCount: obj.count,
            };
          }
          index++;
        }
      }

      sumArray.sort((val1, val2) => {
        if (val2.totalCount != val1.totalCount)
          return val2.totalCount - val1.totalCount;
        return val1.city - val2.city;
      });
      graphApiResponse.datasets = graphApiResponse.datasets.map((apiData) => {
        const sortedData = [];
        sumArray.forEach((data) => {
          sortedData.push(apiData.data[data.index]);
        });
        const returnData = {
          ...apiData,
          data: sortedData,
        };
        return returnData;
      });

      const listOfTopics = [" ", ...graphApiResponse.labels];
      let socialCities = [];
      const topicWiseData = graphApiResponse.datasets;
      socialCities = topicWiseData.map(({ data }) =>
        data.map(({ city }) => city)
      );
      // const listOfCities = [...new Set(...socialCities, ...socialCityMaster)];
      const listOfCities = [...new Set(...socialCities)];
      return (
        <div className="customTableWrap">
          <div className="widgetHeading">{chartTitle}</div>
          <Table
            bordered
            responsive
            id={identifier}
            className="table table-sm table-bordered customTable"
          >
            {" "}
            <thead>
              <tr>
                {
                  //Table header - topic names
                  listOfTopics.map((topicName) => {
                    if (!topicName) {
                      return null;
                    }
                    return <th className="text-center">{topicName}</th>;
                  })
                }
              </tr>
            </thead>
            <tbody>
              {listOfCities.map((city, index) => {
                if (!city) {
                  return null;
                }
                return (
                  <>
                    <tr>
                      <td>
                        <strong>{city}</strong>
                      </td>
                      {topicWiseData.map((twd) => {
                        const cityWiseData = twd.data;
                        const faceValue = cityWiseData.filter(
                          (cwd) => cwd.city == city
                        )[0].count;
                        return (
                          <td className="text-center">
                            <span
                              onClick={(e) => {
                                handleCountClick(e, {
                                  legend: city,
                                  label: twd.label,
                                });
                              }}
                              className="link articleCnt"
                            >
                              {faceValue || 0}
                            </span>
                          </td>
                        );
                      })}
                    </tr>
                  </>
                );
              })}
            </tbody>
          </Table>
        </div>
      );
    } catch (e) { }
  }

  if (reportType === MediaExposureReport) {
    return (
      <div className="customTableWrap">
        <div className="widgetHeading">{chartTitle}</div>
        <div className="table-responsive">
          <table
            id={identifier}
            className="table table-sm table-bordered customTable"
          >
            {Array.isArray(graphApiResponse) &&
              graphApiResponse.map((el) => {
                const {
                  client_name,
                  client_id,
                  NoofArticles,
                  UniqueNoofArticles,
                  circulation,
                  UniqueJournalists,
                  UniqueCities,
                  ccm,
                  mav,
                  UniquePublications,
                } = el || {};
                return (
                  <React.Fragment key={client_id}>
                    <tr>
                      <th className="thHeading">ID</th>
                      <td className="tdData">{client_id || DATA_NOT_FOUND}</td>
                      <th>Client Name</th>
                      <td>{client_name || DATA_NOT_FOUND}</td>
                    </tr>
                    <tr>
                      <th>Article Count</th>
                      <td>{NoofArticles || DATA_NOT_FOUND}</td>
                      <th>Unique Article Count </th>
                      <td>{UniqueNoofArticles || DATA_NOT_FOUND}</td>
                    </tr>
                    <tr>
                      <th>Circulation</th>
                      <td>{circulation || DATA_NOT_FOUND}</td>
                      <th>MAV</th>
                      <td>{mav || DATA_NOT_FOUND}</td>
                    </tr>
                    <tr>
                      <th>CCM</th>
                      <td>{ccm || DATA_NOT_FOUND}</td>
                      <th>Unique Publications</th>
                      <td>{UniquePublications || DATA_NOT_FOUND}</td>
                    </tr>
                    <tr>
                      <th>Unique Cities</th>
                      <td>{UniqueCities || DATA_NOT_FOUND}</td>
                      <th>Unique Journalists</th>
                      <td>{UniqueJournalists || DATA_NOT_FOUND}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </table>
        </div>
      </div>
    );
  }

  if (reportType === KeywordCloudNOA) {
    let listOfDataLabels = graphApiResponse.map((res) => res.name);
    let listOFDataSetLables = [" ", ...graphApiResponse.map((e) => e.weight)];
    let firstColumnTitle = "Keywords";

    return (
      <div className="customTableWrap">
        <Table bordered responsive id={identifier} className="customTable">
          {" "}
          <thead>
            <tr>
              <th>{firstColumnTitle}</th>
              <th className="text-center">Article count</th>
            </tr>
          </thead>
          <tbody>
            {listOfDataLabels.map((lbl, index) => {
              if (typeof lbl == "undefined") {
                return null;
              }
              const currentDataset = graphApiResponse[index];
              const currentDatasetLabel =
                (currentDataset && currentDataset.name) || "";
              const currentDatasetValue =
                (currentDataset && currentDataset.weight) || 0;
              return (
                <>
                  <tr>
                    <td>
                      <strong>{currentDatasetLabel}</strong>
                    </td>
                    <td className="text-center">
                      {" "}
                      <span
                        onClick={(e) =>
                          handleCountClick(e, {
                            legend: currentDatasetLabel,
                            label: currentDatasetValue,
                          })
                        }
                        className="link articleCnt"
                      >
                        {currentDatasetValue || 0}
                      </span>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  if (
    reportType === SOVNOARanking ||
    reportType == TopLanguages ||
    reportType == SOVCCMRanking ||
    reportType == SOVMAVRanking
  ) {
    let listOfDataLabels = [];
    let listOFDataSetLables = [];
    let firstColumnTitle = "Entities";
    if (reportType == KeywordCloudNOA) {
      listOfDataLabels = graphApiResponse.map((res) => res.text);
      listOFDataSetLables = [" ", ...graphApiResponse.map((e) => e.value)];
    } else {
      listOfDataLabels = graphApiResponse.labels;
      if (reportType == TopLanguages) {
        firstColumnTitle = "Languages";
      }
      listOFDataSetLables = [
        " ",
        ...graphApiResponse.datasets.map((e) => e.label),
      ];
    }
    return (
      <div className="customTableWrap">
        <Table bordered responsive id={identifier} className="customTable">
          {" "}
          <thead>
            <tr>
              <th>{firstColumnTitle}</th>
              <th className="text-center">Article count</th>
            </tr>
          </thead>
          <tbody>
            {listOfDataLabels.map((lbl, index) => {
              if (!lbl) {
                return null;
              }
              const currentDataset = graphApiResponse.datasets[0];
              const currentDatasetData =
                (currentDataset && currentDataset.data) || [];
              return (
                <>
                  <tr>
                    <td>
                      <strong>{lbl}</strong>
                    </td>
                    <td className="text-center">
                      {" "}
                      <span
                        onClick={(e) =>
                          handleCountClick(e, {
                            legend: lbl,
                            label: listOFDataSetLables[index + 1],
                          })
                        }
                        className="articleCnt"
                      >
                        {currentDatasetData[index] || 0}
                      </span>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
  if (
    reportType === ThematicReportWithTopicArticle ||
    reportType === ThematicReportWithTopicIndex ||
    reportType === ThematicReportThemeWiseSpreadRanking ||
    reportType === GeolocationZoneWiseTopPublication ||
    reportType === GeolocationMarketSpread
  ) {
    const labels = graphApiResponse.labels;
    const data = graphApiResponse.datasets;
    if (data.length < 1)
      return (
        <h6
          style={{
            textAlign: "center",
            marginTop: "25%",
          }}
        >
          {chartTitle}: No data available.
        </h6>
      );
    return (
      <div className="customTableWrap">
        <div className="tableHeading">{chartTitle}</div>
        <Table bordered responsive id={identifier} className="customTable">
          {" "}
          <thead>
            <tr>
              {labels.map((label, idx) => (
                <td key={label + idx}>
                  <strong>{label}</strong>
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((set, idx) => (
              <tr key={set + idx}>
                {set.map((entry, indx) =>
                  indx === 0 ? (
                    <td key={idx.toString() + indx}>
                      <strong>{entry}</strong>
                    </td>
                  ) : (
                    <td key={idx.toString() + indx}>{entry}</td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
  const listOfDataLabels = [" ", ...graphApiResponse.labels];
  const listOFDataSetLables = [
    ...graphApiResponse.datasets.map((e) => e.label),
  ];

  if (
    reportType === SENTIMENTTABLEARTICLE ||
    reportType === SENTIMENTTABLEINDEX
  ) {
    if (graphApiResponse?.labels.length < 1)
      return (
        <h6
          style={{
            textAlign: "center",
            marginTop: "25%",
          }}
        >
          {chartTitle}: No data available.
        </h6>
      );
    return (
      <div className="customTableWrap">
        <div className="tableHeading">{chartTitle}</div>
        <Table bordered responsive id={identifier} className="customTable">
          <thead>
            <tr>
              {listOfDataLabels.map((dsl) => {
                if (!dsl) {
                  return null;
                }
                return <th className="text-center">{dsl}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {listOFDataSetLables.map((lbl, index) => {
              if (!lbl) {
                return null;
              }
              const currentDataset = graphApiResponse.datasets[index];
              const currentDatasetData =
                (currentDataset && currentDataset.data) || [];
              return (
                <>
                  <tr>
                    <td>
                      <strong>{lbl}</strong>
                    </td>
                    {currentDatasetData.map((articleCnt, index) => {
                      if (typeof articleCnt === "undefined") {
                        return null;
                      }
                      return (
                        <td className="text-center">
                          <span
                            onClick={(e) =>
                              handleCountClick(e, {
                                legend: lbl,
                                label: listOfDataLabels[index + 1],
                              })
                            }
                            className="link articleCnt"
                          >
                            {articleCnt || 0}
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                </>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
  if (reportType == WorldMap) {
    if (!countryWiseFeeds) return;
    let entry = [];
    for (let c in countryWiseFeeds) {
      const temp = {};
      temp.country = c;
      const currentObj = countryWiseFeeds[c];
      temp.feedsCount = (currentObj && currentObj.feedsCount) || 0;
      entry.push(temp);
    }
    entry.length && entry.sort((a, b) => b.feedsCount - a.feedsCount);
    return (
      <div className="customTableWrap">
        <Table bordered responsive id={identifier} className="customTable">
          {" "}
          <thead>
            <tr>
              <th>Country</th>
              <th className="text-center">Article count</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(entry) &&
              entry.map((countryItem) => {
                if (!countryItem) {
                  return null;
                }
                const { country, feedsCount } = countryItem;
                return (
                  <>
                    <tr>
                      <td>
                        <strong>{country}</strong>
                      </td>
                      <td className="text-center">
                        {" "}
                        <span
                          onClick={(e) =>
                            handleCountClick(e, {
                              legend: country,
                            })
                          }
                          className="link articleCnt"
                        >
                          {feedsCount}
                        </span>
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </Table>
      </div>
    );
  }

  return (
    <div className="customTableWrap">
      <Table bordered responsive id={identifier} className="customTable">
        <thead>
          <tr>
            {listOfDataLabels.map((dsl) => {
              if (!dsl) {
                return null;
              }
              return <th className="text-center">{dsl}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {listOFDataSetLables.map((lbl, index) => {
            if (!lbl) {
              return null;
            }
            const currentDataset = graphApiResponse.datasets[index];
            const currentDatasetData =
              (currentDataset && currentDataset.data) || [];
            return (
              <>
                <tr>
                  <td>
                    <strong>{lbl}</strong>
                  </td>
                  {currentDatasetData.map((articleCnt, index) => {
                    if (typeof articleCnt === "undefined") {
                      return null;
                    }
                    return (
                      <td className="text-center">
                        <span
                          onClick={(e) =>
                            handleCountClick(e, {
                              legend: lbl,
                              label: listOfDataLabels[index + 1],
                            })
                          }
                          className="link articleCnt"
                        >
                          {articleCnt || 0}
                        </span>
                      </td>
                    );
                  })}
                </tr>
              </>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};
